var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Комментарий для администратора")]),_c('ModelTextArea',{attrs:{"label":"Напишите комментарий","disabled":_vm.loading},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_c('Button',{attrs:{"lass":"btn_send","disabled":!_vm.canSend},on:{"click":_vm.send}},[_vm._v("Отправить")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }